import * as React from "react"

import { cn } from "@shared/lib/utils"

export interface InputProps extends React.ComponentProps<"input"> {
  /** When true, applies destructive border styling */
  error?: boolean
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, error, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "flex h-9 w-full rounded-[10px] border border-input bg-card px-3 py-2 text-base file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground placeholder:font-normal focus:outline-none focus:border-foreground transition-colors disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
          error && "border-destructive focus:border-destructive",
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
